import { useContext, useEffect, useState } from 'react';
import CartItem from '../components/CartItem';
import DeliveryForm from '../components/DeliveryForm';
import { CartContext } from '../context/CartContext';
import { chargePayment } from '../services/PaymentService';

const CartPage = () => {
  const { state, clearCart, handleQuantityChange, enviarPedido } = useContext(CartContext);

  const [culqiReady, setCulqiReady] = useState(false);

  const [nombre, setNombre] = useState('');
  const [correoElectronico, setCorreoElectronico] = useState('');
  const [direccion, setDireccion] = useState('');
  const [telefono, setTelefono] = useState('');
  const [instrucciones, setInstrucciones] = useState('');

  // Load Culqi script
  useEffect(() => {
    if (window.CulqiCheckout) {
      setCulqiReady(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://js.culqi.com/checkout-js';
    script.async = true;

    script.onload = () => {
      setCulqiReady(true);
    };

    document.body.appendChild(script);
  }, []);

  // Culqi payment
  const handlePayment = () => {
    if (!culqiReady) {
      alert('Culqi no está listo todavía');
      return;
    }

    const publicKey = process.env.REACT_APP_CULQI_PUBLIC_KEY;

    const settings = {
      title: 'Mi Tienda',
      currency: 'PEN',
      amount: Math.round(state.cartTotal * 100),
    };

    const client = {
      email: correoElectronico,
    };

    const options = {
      lang: 'es',
      installments: true,
      paymentMethods: {
        tarjeta: true,
        yape: true,
        billetera: true,
        bancaMovil: true,
        agente: true,
      },
    };

    const config = {
      settings,
      client,
      options,
    };

    const Culqi = new window.CulqiCheckout(publicKey, config);

    Culqi.culqi = async () => {
      if (Culqi.token) {
        const token = Culqi.token.id;

        try {
          const response = await chargePayment({
            token,
            amount: Math.round(state.cartTotal * 100),
            nombre,
            correoElectronico,
            direccion,
            telefono,
            instrucciones,
            cart: state.cart,
          });

          console.log('Charge response:', response);

          alert('¡Pago exitoso!');

          // optional - uncomment to auto-submit order after payment
          // enviarPedido(null, {
          //   nombre,
          //   correoElectronico,
          //   direccion,
          //   telefono,
          //   instrucciones,
          // });

        } catch (error) {
          console.error('Payment error:', error);
          alert('Error procesando pago: ' + error.message);
        }
      } else {
        console.log(Culqi.error);
        alert(Culqi.error.user_message);
      }
    };

    Culqi.open();
  };

  return (
    <section className="h-100 h-custom" style={{ backgroundColor: '#ffffff' }}>
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-top h-100">
          <div className="col-12">
            <div className="card card-registration card-registration-2" style={{ borderRadius: '15px' }}>
              <div className="card-body p-0">
                <div className="row g-0">

                  {/* Cart Items */}
                  <div className="col-12 col-lg-8">
                    <div className="p-5">
                      <div className="d-flex justify-content-between align-items-center mb-5">
                        <h1 className="fw-bold mb-0">Carrito de Compras</h1>
                        <h6 className="mb-0 text-muted">{state.cartCount} Items</h6>
                      </div>

                      <hr className="my-4" />

                      {state.cart.length === 0 ? (
                        <p>No hay productos en el carrito.</p>
                      ) : (
                        state.cart.map((item, index) => (
                          <CartItem
                            key={index}
                            item={item}
                            onQuantityChange={handleQuantityChange}
                          />
                        ))
                      )}

                      <hr className="my-4" />

                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-danger" onClick={clearCart}>
                          Limpiar Carrito
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Order Summary */}
                  <div className="col-12 col-lg-4 bg-body-tertiary">
                    <div className="p-5">
                      <h3 className="fw-bold mb-5 mt-2 pt-1">Resumen</h3>

                      <hr className="my-4" />

                      <div className="mb-4">
                        <h5 className="text-uppercase">{state.cartCount} Items</h5>
                        <h5>S/. {state.cartTotal}</h5>
                      </div>

                      <hr className="my-4" />

                      <h5 className="mb-3">Datos de entrega prueba</h5>

                      <DeliveryForm
                        nombre={nombre}
                        setNombre={setNombre}
                        correoElectronico={correoElectronico}
                        setCorreoElectronico={setCorreoElectronico}
                        direccion={direccion}
                        setDireccion={setDireccion}
                        telefono={telefono}
                        setTelefono={setTelefono}
                        instrucciones={instrucciones}
                        setInstrucciones={setInstrucciones}
                        onSubmit={(e) => {
                          e.preventDefault();
                          handlePayment();
                        }}
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartPage;